import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { redirect } from '../../common/utils/redirectionUtils'
import {
    HEADER_CONFIG,
    HEADER_CONST,
    SIDEBAR_CONST
} from '../../common/constant/common-constant'
import {
    PAGE_CONST,
    PERMISSION_FEATURE,
    PERMISSION_SCREEN
} from '../../common/constant/page-constant'
import Header from '../Common/Header/Header'
import SideMenu from '../Common/SideMenu/SideMenu'

import './Help.scss'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import MobileHeader from '../Common/Header/MobileHeader'
import SideDrawer from '../Common/SideDrawer/SideDrawer'
import AddIcon from '../../assets/AddIcon'
import { addQueryHelper, getQueryHelper, updateQueryHelper, deleteQueryHelper } from '../../helper/query-helper'
import { addQueryAlertAction } from '../../modules/actions/action'
import Alert from '../../components/Alert/Alert'
import { formatDate } from '../../common/utils/appUtils'
import AcknowledgeScreen from '../Common/AcknowledgeScreen/AcknowledgeScreen'
import CheckPrimaryIcon from '../../assets/CheckPrimaryIcon'
import AttachIcon from '../../assets/AttachIcon'
import CloseIcon from '../../assets/CloseIcon'
import DotsIcon from '../../assets/DotsIcon'
import PopupCard from '../Common/PopupCard/PopupCard'

const MAX_WORDS = 300
const MAX_FILE_SIZE = 5 * 1024 * 1024 // 5MB in bytes
const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
const ALLOWED_FILE_EXTENSIONS = '.jpg, .jpeg, .png, .gif, .webp, .pdf, .doc, .docx'
const QUERY_STATUS = {
    NEW: 'NEW',
    IN_PROGRESS: 'IN_PROGRESS',
    RESOLVED: 'RESOLVED',
    CLOSED: 'CLOSED'
}

const Help = props => {
    const navigate = useNavigate()
    const isMobile = useCheckMobileScreen()
    const [viewDrawer, setViewDrawer] = useState(false)
    const [open, setOpen] = useState(false)
    const [headerOptions, setHeaderOptions] = useState({
        [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
        [HEADER_CONFIG.TITLE]: HEADER_CONST.HELP,
        [HEADER_CONFIG.HANDLE_BACK_FUNC]: () =>
            redirect(navigate, PAGE_CONST.PROFILE_MENU)
    })
    const [subject, setSubject] = useState(undefined)
    const [query, setQuery] = useState(undefined)
    const [queryList, setQueryList] = useState([])
    const [addQueryAlert, setAddQueryAlert] = useState(false)
    const [isFieldErrorVisible, setIsFieldErrorVisible] = useState(false)
    const [permissions, setPermissions] = useState({})
    const [attachment, setAttachment] = useState(null)
    const [attachmentName, setAttachmentName] = useState('')
    const [wordCount, setWordCount] = useState(0)
    const [editMode, setEditMode] = useState(false)
    const [editingQueryId, setEditingQueryId] = useState(null)
    const [deleteQueryPopup, setDeleteQueryPopup] = useState(null)
    const [isDeletingQuery, setIsDeletingQuery] = useState(false)
    const [activeCardMenu, setActiveCardMenu] = useState(null)
    const [activeTab, setActiveTab] = useState(QUERY_STATUS.NEW)
    const [fileError, setFileError] = useState('')
    const fileInputRef = useRef(null)
    const mobileFileInputRef = useRef(null)

    useEffect(() => {
        let addQueryAlert = props.alert?.addQueryAlert
        // setAddQueryAlert(addQueryAlert)
    }, [props.alert?.addQueryAlert])

    useEffect(() => {
        getQuery()
    }, [])

    useEffect(() => {
        if (props.loginData.permissions) {
            let permission = props.loginData.permissions.filter(
                permission => permission.screen === PERMISSION_SCREEN.SETTINGS
            )[0]

            if (permission) setPermissions(permission)
        }
    }, [props.loginData])

    const getQuery = () => {
        getQueryHelper()
            .then(res => {
                setQueryList(res)
            })
            .catch(err => {
                console.log('get query err: ', err)
            })
    }

    const countWords = (text) => {
        if (!text || text.trim() === '') return 0
        return text.trim().split(/\s+/).length
    }

    const handleQueryChange = (value) => {
        const words = countWords(value)
        if (words <= MAX_WORDS) {
            setQuery(value)
            setWordCount(words)
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        if (file) {
            // Validate file size
            if (file.size > MAX_FILE_SIZE) {
                setFileError(`File size exceeds 5MB limit. Your file: ${(file.size / (1024 * 1024)).toFixed(2)}MB`)
                e.target.value = ''
                return
            }
            
            // Validate file type
            if (!ALLOWED_FILE_TYPES.includes(file.type)) {
                setFileError(`Invalid file format. Allowed: ${ALLOWED_FILE_EXTENSIONS}`)
                e.target.value = ''
                return
            }
            
            setFileError('')
            setAttachment(file)
            setAttachmentName(file.name)
        }
    }

    const handleRemoveAttachment = () => {
        setAttachment(null)
        setAttachmentName('')
        setFileError('')
        if (fileInputRef.current) fileInputRef.current.value = ''
        if (mobileFileInputRef.current) mobileFileInputRef.current.value = ''
    }

    const handleEditQuery = (queryItem) => {
        setEditMode(true)
        setEditingQueryId(queryItem.id)
        setSubject(queryItem.subject)
        setQuery(queryItem.query)
        setWordCount(countWords(queryItem.query))
        if (queryItem.attachment_name) {
            setAttachmentName(queryItem.attachment_name)
        }
        setActiveCardMenu(null)
        
        // On mobile, open the drawer
        if (isMobile) {
            setOpen(true)
            setViewDrawer(true)
        }
    }

    const handleDeleteQuery = (queryItem) => {
        if (isDeletingQuery) return
        
        setIsDeletingQuery(true)
        deleteQueryHelper(queryItem.id)
            .then(res => {
                console.log('delete query res: ', res)
                setDeleteQueryPopup(null)
                getQuery()
            })
            .catch(err => {
                console.log('delete query err: ', err)
            })
            .finally(() => {
                setIsDeletingQuery(false)
            })
    }

    const cancelEdit = () => {
        setEditMode(false)
        setEditingQueryId(null)
        resetDrawerData()
    }

    const handleQuerySubmit = () => {
        if (!handleValidation()) {
            setIsFieldErrorVisible(true)
            return
        }

        setIsFieldErrorVisible(false)
        
        let data = new FormData()
        data.append('subject', subject)
        data.append('query', query)
        data.append('status', QUERY_STATUS.NEW)
        if (attachment) {
            data.append('attachment', attachment)
        }

        if (editMode) {
            data.append('id', editingQueryId)
            updateQueryHelper(data)
                .then(res => {
                    console.log('query update res: ', res)

                    props.addQueryAlertAction(true)

                    setTimeout(() => {
                        props.addQueryAlertAction(false)
                    }, 5000)

                    resetDrawerData()
                    setEditMode(false)
                    setEditingQueryId(null)
                    if (isMobile) {
                        handleDrawerToggle()
                    }

                    getQuery()
                })
                .catch(err => {
                    console.log('query update err: ', err)
                })
        } else {
            addQueryHelper(data)
                .then(res => {
                    console.log('query submit res: ', res)

                    props.addQueryAlertAction(true)

                    setTimeout(() => {
                        props.addQueryAlertAction(false)
                    }, 5000)

                    resetDrawerData()
                    if (isMobile) {
                        handleDrawerToggle()
                    }

                    getQuery()
                })
                .catch(err => {
                    console.log('query submit err: ', err)
                })
        }
    }

    const handleValidation = () => {
        if (subject && query) return true

        console.log('validation failed')
        return false
    }

    const handleDrawerToggle = () => {
        setViewDrawer(!viewDrawer)
        setOpen(!open)
        if (open && editMode) {
            cancelEdit()
        }
    }

    const resetDrawerData = () => {
        setSubject('')
        setQuery('')
        setAttachment(null)
        setAttachmentName('')
        setWordCount(0)
        setEditMode(false)
        setEditingQueryId(null)
        setFileError('')
        if (fileInputRef.current) fileInputRef.current.value = ''
        if (mobileFileInputRef.current) mobileFileInputRef.current.value = ''
    }

    const toggleCardMenu = (queryId) => {
        setActiveCardMenu(activeCardMenu === queryId ? null : queryId)
    }

    const getFilteredQueries = () => {
        return queryList.filter(q => {
            const status = q.status || QUERY_STATUS.NEW
            return status === activeTab
        })
    }

    const renderQueryCard = (queryItem) => {
        const isPending = [QUERY_STATUS.NEW, QUERY_STATUS.IN_PROGRESS].includes(queryItem.status || QUERY_STATUS.NEW)
        
        return (
            <div className="card helpCard" key={queryItem.id}>
                <div className="helpCardHeader">
                    {queryItem.query_id && (
                        <div className="queryIdBadge">
                            Query ID: {queryItem.query_id}
                        </div>
                    )}
                    {isPending && (
                        <div className="helpCardActions">
                            {activeCardMenu === queryItem.id ? (
                                <span
                                    className="menuIcon"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        setActiveCardMenu(null)
                                    }}
                                >
                                    <CloseIcon />
                                </span>
                            ) : (
                                <span
                                    className="menuIcon"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        toggleCardMenu(queryItem.id)
                                    }}
                                >
                                    <DotsIcon />
                                </span>
                            )}
                            <ul className={`cardActionsWrapper ${activeCardMenu === queryItem.id ? 'show' : 'hide'}`}>
                                <li
                                    className="actionItem"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        handleEditQuery(queryItem)
                                    }}
                                >
                                    Edit
                                </li>
                                <li
                                    className="actionItem"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        setActiveCardMenu(null)
                                        setDeleteQueryPopup(queryItem)
                                    }}
                                >
                                    Remove
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
                <div className="cardSection cardBody">
                    <small>Date</small>
                    <div className="helpIssue">
                        {formatDate(queryItem.date)}
                    </div>
                </div>
                <div className="cardSection cardBody">
                    <small>Subject</small>
                    <div className="helpIssue">
                        {queryItem.subject}
                    </div>
                </div>
                <div className="cardSection cardBody">
                    <small>Query</small>
                    <div className="helpIssue queryText">
                        {queryItem.query}
                    </div>
                </div>
                {queryItem.attachment_name && (
                    <div className="cardSection cardFooter">
                        <small>Attachment</small>
                        <div className="helpIssue attachmentInfo">
                            <AttachIcon />
                            <span>{queryItem.attachment_name}</span>
                        </div>
                    </div>
                )}
                {queryItem.status === QUERY_STATUS.RESOLVED && queryItem.resolution && (
                    <div className="cardSection cardFooter resolutionSection">
                        <small>Resolution</small>
                        <div className="helpIssue resolutionText">
                            {queryItem.resolution}
                        </div>
                    </div>
                )}
            </div>
        )
    }

    return (
        <>
            {isMobile && <MobileHeader headerOptions={headerOptions} />}

            {!isMobile && <Header />}
            {addQueryAlert && (
                <AcknowledgeScreen
                    icon={<CheckPrimaryIcon />}
                    alertType="success"
                    alertMessage="Query added Successfully!"
                    main="Query added Successfully!"
                    sub=""
                />
            )}
            <SideMenu
                activeItem={PAGE_CONST.HELP}
                component={PAGE_CONST.HELP}
            />
            <div className="pageBody helpPageBody">
                {isMobile && (
                    <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
                        <button
                            className="animated zoomIn btn btnPrimary"
                            onClick={handleDrawerToggle}>
                            <AddIcon />
                        </button>
                    </div>
                )}
                <div className="helpContentWrapper">
                    <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter webVisible mb-5">
                        <div className="pageBodyRightPanelHeading">Help</div>
                    </div>
                    <div className="pageBodyPanelWrap">
                    <div className="pageBodyLeftPanel">
                        {/* Tab Navigation */}
                        <div className="helpTabsWrapper">
                            <ul className="tabs dFlex">
                                <li
                                    className={`tabItem ${activeTab === QUERY_STATUS.NEW ? 'active' : ''}`}
                                    onClick={() => setActiveTab(QUERY_STATUS.NEW)}
                                >
                                    New
                                </li>
                                <li
                                    className={`tabItem ${activeTab === QUERY_STATUS.IN_PROGRESS ? 'active' : ''}`}
                                    onClick={() => setActiveTab(QUERY_STATUS.IN_PROGRESS)}
                                >
                                    In Progress
                                </li>
                                <li
                                    className={`tabItem ${activeTab === QUERY_STATUS.RESOLVED ? 'active' : ''}`}
                                    onClick={() => setActiveTab(QUERY_STATUS.RESOLVED)}
                                >
                                    Resolved
                                </li>
                                <li
                                    className={`tabItem ${activeTab === QUERY_STATUS.CLOSED ? 'active' : ''}`}
                                    onClick={() => setActiveTab(QUERY_STATUS.CLOSED)}
                                >
                                    Closed
                                </li>
                            </ul>
                        </div>
                        
                        {/* Query Cards */}
                        <div className="tabContent">
                            <div className="queryCardsContainer">
                                {getFilteredQueries().length > 0 ? (
                                    getFilteredQueries().map(queryItem => renderQueryCard(queryItem))
                                ) : (
                                    <div className="emptyState">
                                        <p>No {activeTab.replace('_', ' ').toLowerCase()} queries found.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    
                    {!isMobile && (
                        <div className="pageBodyRightPanel">
                            <form>
                                <div className="panelHeadingRow">
                                    <div className="panelHeading">{editMode ? 'Edit Query' : 'Add Query'}</div>
                                    {editMode && (
                                        <button 
                                            type="button" 
                                            className="cancelEditBtn"
                                            onClick={cancelEdit}
                                        >
                                            <CloseIcon />
                                        </button>
                                    )}
                                </div>
                                
                                <div className="formGroup formFloating fgrow1">
                                    <input
                                        type="text"
                                        className="formControl"
                                        id="subject"
                                        value={subject}
                                        onChange={event =>
                                            setSubject(event.target.value)
                                        }
                                        placeholder="Subject"
                                        required
                                    />
                                    <label htmlFor="subject">Subject</label>
                                    {isFieldErrorVisible && !subject && (
                                        <div className="invalidFeedback">
                                            Please select a valid Subject
                                        </div>
                                    )}
                                </div>
                                <div className="formGroup formFloating">
                                    <textarea
                                        rows="4"
                                        type="text"
                                        value={query}
                                        onChange={event =>
                                            handleQueryChange(event.target.value)
                                        }
                                        className="formControl queryTextarea"
                                        placeholder="Query"
                                        id="queryInput"
                                        required></textarea>
                                    <label htmlFor="queryInput">Query</label>
                                    <div className="wordCountInfo">
                                        <span className={wordCount >= MAX_WORDS ? 'limitReached' : ''}>
                                            {wordCount}/{MAX_WORDS} words
                                        </span>
                                    </div>
                                    {isFieldErrorVisible && !query && (
                                        <div className="invalidFeedback">
                                            Please enter query.
                                        </div>
                                    )}
                                </div>
                                
                                <div className="formGroup attachmentGroup">
                                    <label className="attachmentLabel">Attachment (optional)</label>
                                    <div className="fileInfoNote">
                                        Max size: 5MB | Formats: JPG, PNG, GIF, PDF, DOC, DOCX
                                    </div>
                                    <div className="attachmentInputRow">
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            className="fileInput"
                                            id="attachmentFile"
                                            accept="image/*,.pdf,.doc,.docx"
                                            onChange={handleFileChange}
                                        />
                                        <label className="attachBtn" htmlFor="attachmentFile">
                                            <AttachIcon />
                                            <span>Choose File</span>
                                        </label>
                                        {attachmentName && (
                                            <div className="attachedFileInfo">
                                                <span className="fileName">{attachmentName}</span>
                                                <button 
                                                    type="button" 
                                                    className="removeFileBtn"
                                                    onClick={handleRemoveAttachment}
                                                >
                                                    <CloseIcon />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                    {fileError && (
                                        <div className="fileErrorMessage">
                                            {fileError}
                                        </div>
                                    )}
                                </div>
                                
                                <div
                                    className="actionRow"
                                    onClick={event => {
                                        event.preventDefault()
                                        handleQuerySubmit()
                                    }}>
                                    <button className="btn btnPrimary block">
                                        {editMode ? 'Update' : 'Submit'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                    </div>
                </div>
                
                {/* Mobile Side Drawer */}
                <SideDrawer
                    handleDrawerToggle={() => {
                        handleDrawerToggle()
                        if (editMode) cancelEdit()
                    }}
                    open={open}
                    drawerButton={true}
                    buttonText={editMode ? 'Update' : 'Submit'}
                    handleClick={handleQuerySubmit}
                    drawerHeading={editMode ? 'Edit Query' : 'Add Query'}
                    mwebSideDrawerFooter>
                    <form>
                        <div className="formGroup formFloating fgrow1">
                            <input
                                type="text"
                                className="formControl"
                                id="mobileSubject"
                                value={subject}
                                onChange={event =>
                                    setSubject(event.target.value)
                                }
                                placeholder="Subject"
                                required
                            />
                            <label htmlFor="mobileSubject">Subject</label>
                            {isFieldErrorVisible && !subject && (
                                <div className="invalidFeedback">
                                    Please select a valid Subject
                                </div>
                            )}
                        </div>
                        <div className="formGroup formFloating">
                            <textarea
                                rows="4"
                                type="text"
                                value={query}
                                className="formControl queryTextarea"
                                onChange={event => handleQueryChange(event.target.value)}
                                id="mobileQuery"
                                placeholder="Query"
                                required></textarea>
                            <label htmlFor="mobileQuery">Query</label>
                            <div className="wordCountInfo">
                                <span className={wordCount >= MAX_WORDS ? 'limitReached' : ''}>
                                    {wordCount}/{MAX_WORDS} words
                                </span>
                            </div>
                            {isFieldErrorVisible && !query && (
                                <div className="invalidFeedback">
                                    Please enter query.
                                </div>
                            )}
                        </div>
                        
                        <div className="formGroup attachmentGroup">
                            <label className="attachmentLabel">Attachment (optional)</label>
                            <div className="fileInfoNote">
                                Max size: 5MB | Formats: JPG, PNG, GIF, PDF, DOC, DOCX
                            </div>
                            <div className="attachmentInputRow">
                                <input
                                    type="file"
                                    ref={mobileFileInputRef}
                                    className="fileInput"
                                    id="mobileAttachmentFile"
                                    accept="image/*,.pdf,.doc,.docx"
                                    onChange={handleFileChange}
                                />
                                <label className="attachBtn" htmlFor="mobileAttachmentFile">
                                    <AttachIcon />
                                    <span>Choose File</span>
                                </label>
                                {attachmentName && (
                                    <div className="attachedFileInfo">
                                        <span className="fileName">{attachmentName}</span>
                                        <button 
                                            type="button" 
                                            className="removeFileBtn"
                                            onClick={handleRemoveAttachment}
                                        >
                                            <CloseIcon />
                                        </button>
                                    </div>
                                )}
                            </div>
                            {fileError && (
                                <div className="fileErrorMessage">
                                    {fileError}
                                </div>
                            )}
                        </div>
                    </form>
                </SideDrawer>

                {/* Delete Confirmation Popup */}
                {deleteQueryPopup && (
                    <PopupCard
                        header={`Delete Query ${deleteQueryPopup.query_id || ''}`}
                        body={`Are you sure you want to permanently delete this query "${deleteQueryPopup.subject}"? This action cannot be undone.`}
                    >
                        <button
                            className="btn btnPrimaryOutlined dFlex"
                            onClick={() => setDeleteQueryPopup(null)}
                            disabled={isDeletingQuery}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btnDanger dFlex"
                            onClick={() => handleDeleteQuery(deleteQueryPopup)}
                            disabled={isDeletingQuery}
                        >
                            {isDeletingQuery ? 'Deleting...' : 'Delete Query'}
                        </button>
                    </PopupCard>
                )}
            </div>
        </>
    )
}

const mapStateToProps = state => {
    return {
        alert: state.alertReducer.alert,
        loginData: state.loginDataReducer?.loginData
    }
}
const mapDispatchToProps = dispatch => {
    return {
        addQueryAlertAction: payload => dispatch(addQueryAlertAction(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Help)
